import React from 'react'
import { Button, Popup, Icon } from 'semantic-ui-react'
import styled, { ThemeProvider } from 'styled-components';


import theme from '~/theme';
import { __ } from '~/i18n'
import { formatMoney } from '~/utils/money'

import PriceBox from './price-box'

const BuyButtonContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  
  .ui.button {
    margin-right: 0;
    min-width: 128px;
    ${props => (props.showPriceBox ? 'border-top-left-radius: 0; border-top-right-radius: 0;' : '')} 
  }
`;

export default class BuyButton extends React.PureComponent {

  static defaultProps = {
    showPrice: false,
    showPriceBox: false,
    largePriceBox: false,
    buttonColor: null,
    textColor: null,
  };

  handleClick = () => {
    const { product, loading, failed, hasQuantity } = this.props;
    const { addToCart } = this.props.actions;

    if(!loading && !failed && hasQuantity) {
      addToCart(product);
    }
  };

  isDisabled = () => {
    const { loading, failed, hasQuantity } = this.props;
    return loading || failed || !hasQuantity
  };

  getButtonStyles = () => {
    const { buttonColor, textColor } = this.props;
    const disabled = this.isDisabled();
    let styles = {};

    if(buttonColor && !disabled) {
      styles.backgroundColor = buttonColor;
    }

    if(textColor && !disabled) {
      styles.color = textColor;
    }

    return styles;
  };

  getError = () => {
    const { failed, hasQuantity } = this.props;

    if(failed) {
      return __('Error loading product')
    }

    if(!hasQuantity) {
      return __('Out of stock')
    }

    return null;
  };

  showPriceBox = () => {
    const { showPriceBox, largePriceBox, product } = this.props;

    return (showPriceBox || largePriceBox) && product;
  };

  render() {
    const { text, product, showPrice, failed, largePriceBox, loading, children } = this.props;
    const error = this.getError();

    if(product && product.state === 'hidden') {
      return null;
    }

    if (children) {
      const props = {
        text,
        product,
        showPrice,
        failed,
        largePriceBox,
        showPriceBox: this.showPriceBox(),
        onClick: this.handleClick,
        disabled: this.isDisabled(),
        loading: loading
      };
      if(typeof children === 'function') {
        return children(props)
      } else {
        React.Children.only(children)

        return React.cloneElement(children, props)
      }
    }

    const button = (
      <Button
        positive
        disabled={ this.isDisabled() }
        style={ this.getButtonStyles() }
        onClick={ this.handleClick }
      >
        { showPrice && product ? `${formatMoney(product.price, true)} ${text || __('Buy')}` : text || __('Buy') }
      </Button>
    );

    return (
      <ThemeProvider theme={theme}>
        <BuyButtonContainer className="gfy-plugin-container" showPriceBox={ this.showPriceBox() }>
          { this.showPriceBox() ? <PriceBox product={ product } failed={ failed } largePriceBox={ largePriceBox } /> : null }
          { button }
          { error ? <Popup trigger={ <Icon name='exclamation triangle' circular inverted color='red' /> } content={ error } position='right center' on='hover' /> : null }
        </BuyButtonContainer>
      </ThemeProvider>
    )
  }
}
